import type {InjectionKey} from 'vue';

export const PREVIEW_ENABLE_COOKIE = 'malt-prismic-preview-enable';
export const USER_LOCALE: InjectionKey<string> = Symbol('User locale');
